import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import {
    CustomReportSearchClient,
    CustomReportUserFavoriteClient,
    CustomReportView,
    SearchReportTemplateParameters
} from '.././reporting-api-proxies';

export interface IReportsSearchService<TView> {
    searchReports: (body: SearchReportTemplateParameters) => Promise<TView[]>;
    toggleFavorite: (id: number) => Promise<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomReportSearchService implements IReportsSearchService<CustomReportView> {
    constructor(
        private readonly client: CustomReportSearchClient,
        private readonly favoriteClient: CustomReportUserFavoriteClient
    ) {}

    async searchReports(body: SearchReportTemplateParameters): Promise<CustomReportView[]> {
        return await lastValueFrom(this.client.customReportSearchSearchCustomReports(body));
    }

    async searchCatalogReports(body: SearchReportTemplateParameters): Promise<CustomReportView[]> {
        return await lastValueFrom(this.client.customReportSearchSearchCatalogReports(body));
    }

    async toggleFavorite(id: number): Promise<boolean> {
        return await lastValueFrom(this.favoriteClient.customReportUserFavoriteToggleFavorite(id));
    }

    async deactivate(id: number): Promise<void> {
        await lastValueFrom(this.client.customReportSearchDeactivate(id));
    }
}
